import React from "react";
import BuiltYearDetails from "./BuiltYearDetails";
import StringDetails from "./StringDetails";
import EnergyLabelDetails from "./EnergyLabelDetails";

interface DetailsWrapperProps {
  data: any;
  type: string;
}

const DetailsWrapper: React.FC<DetailsWrapperProps> = ({ data, type }) => {
  const PropertyFactComponents: { [key: string]: React.FC<any> } = {
    BuiltYearDetails: BuiltYearDetails,
    StringDetails: StringDetails,
    EnergyLabelDetails: EnergyLabelDetails,
  };
  const Component = PropertyFactComponents[type];
  return <Component {...data} />;
};

export default DetailsWrapper;
